<template>
  <div :class="{
    'c-header': true,
    'c-header--active': index > 0 && index < 14,
    'c-header--open': menuOpen
  }">
    <div class="o-wrapper">
      <div class="c-header__main">
        <a :class="{
          'c-header__logo': true,
          'is-active': index === 13
        }" :href="`https://clubbrugge.be/${lang}`" rel="noopener" target="_blank">
          <img v-if="webP" src="/assets/logo_club.webp" alt="Logo Club Brugge">
          <img v-else src="/assets/logo_club.png" alt="Logo Club Brugge">
        </a>

        <div :class="{
          'c-header__nav': true,
          'is-visible': progress === 100 && (index === 0 || index === 14)
        }">
          <div class="c-nav">
            <div class="c-nav__list">
              <div class="c-nav__item" v-if="index < 13">
                <a :href="`/assets/presskit_${lang}.zip`" target="_blank" class="c-nav__link e-link">{{ globals.presskit }}</a>
              </div>
              <div class="c-nav__item" v-if="index >= 13">
                <a @click.prevent="scrollToHome" href="#" class="c-nav__link e-link">{{ globals.home }}</a>
              </div>
              <div class="c-nav__item">
                <a @click.prevent="windowPopup(`https://twitter.com/intent/tweet/?text=${globals.title}&url=${href}`, 500, 300)" class="c-nav__link c-nav__link-icon" href="https://twitter.com/ClubBrugge" rel="noopener" target="_blank">
                  <img v-if="webP" src="/assets/icon_tw.webp" alt="Twitter logo">
                  <img v-else src="/assets/icon_tw.png" alt="Twitter logo">
                </a>
              </div>
              <div class="c-nav__item u-margin-right-small">
                <a @click.prevent="windowPopup(`https://www.facebook.com/sharer/sharer.php?u=${href}`, 500, 300)" class="c-nav__link c-nav__link-icon" href="https://www.facebook.com/clubbrugge" rel="noopener" target="_blank">
                  <img v-if="webP" src="/assets/icon_fb.webp" alt="Facebook logo">
                  <img v-else src="/assets/icon_fb.png" alt="Facebook logo">
                </a>
              </div>
              <div v-if="lang !== 'nl'" class="c-nav__item">
                <a href="https://debeerenzijnsjaal.be/" class="c-nav__link e-link">NL</a>
              </div>
              <div v-if="lang !== 'fr'" class="c-nav__item">
                <a href="https://loursetsonecharpe.be/" class="c-nav__link e-link">FR</a>
              </div>
              <div v-if="lang !== 'en'" class="c-nav__item">
                <a href="https://thebearandhisscarf.com/" class="c-nav__link e-link">EN</a>
              </div>
            </div>
          </div>
        </div>

        <div class="c-header__toggle" @click.prevent="menuOpen = !menuOpen">
          <img v-if="menuOpen" src="/assets/hamburger-close.svg" alt="">
          <img v-else-if="!menuOpen && isDesktop" src="/assets/hamburger.svg" alt="">
          <img v-else src="/assets/hamburger-black.svg" alt="">
        </div>
      </div>
    </div>

    <div :class="{
      'c-header__menu': true,
      'is-active': menuOpen
      }">
      <Leafs type="header" />
      <div class="u-align-center o-flex c-header-spacing u-padding-bottom">
        <div>
          <div class="c-logo">
            <img :src="`/assets/logo_${lang}.${extension}`" :alt="`Logo ${globals.title}`">
          </div>
        </div>

        <div class="u-margin-top">
          <div class="u-margin-vertical-small">
            <a href="#" class="e-link--underline u-h2" @click.prevent="scrollToHome">{{ globals.home }}</a>
          </div>
          <div v-show="isDesktop" class="u-margin-vertical-small">
            <a :href="`/assets/presskit_${lang}.zip`" target="_blank" class="e-link--underline u-h2">{{ globals.presskit }}</a>
          </div>
          <div class="u-margin-vertical-small c-header__menu-lang">
            <div v-if="lang !== 'nl'">
              <a href="https://debeerenzijnsjaal.be/" class="e-link--underline u-h2">NL</a>
              <!-- <router-link @click.native="menuOpen = false" class="e-link--underline u-h2" to="/nl">NL</router-link> -->
            </div>
            <div v-if="lang !== 'fr'">
              <a href="https://loursetsonecharpe.be/" class="e-link--underline u-h2">FR</a>
              <!-- <router-link @click.native="menuOpen = false" class="e-link--underline u-h2" to="/fr">FR</router-link> -->
            </div>
            <div v-if="lang !== 'en'">
              <a href="https://thebearandhisscarf.com/" class="e-link--underline u-h2">EN</a>
              <!-- <router-link @click.native="menuOpen = false" class="e-link--underline u-h2" to="/en">EN</router-link> -->
            </div>
          </div>
        </div>

        <div class="u-margin-top u-margin-bottom">
          <SocialShare />
        </div>
      </div>

      <div class="o-section__figure-wrapper is-center-center">
        <figure class="o-section__figure" ref="figureE">
          <Img :src="require('@/assets/intro/intro_e.png')" filename="intro_e" />
        </figure>

        <figure class="o-section__figure" ref="figureB">
          <Img :src="require('@/assets/intro/intro_b.png')" filename="intro_b" />
        </figure>

        <figure class="o-section__figure" ref="figureC">
          <Img :src="require('@/assets/intro/intro_c.png')" filename="intro_c" />
        </figure>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SocialShare from '@/components/SocialShare'
import Leafs from '@/components/Leafs'
import Img from '@/components/Img'

export default {
  name: 'Header',
  props: ['index', 'progress', 'isDesktop', 'options'],

  data () {
    return {
      menuOpen: false,
      href: ''
    }
  },

  watch: {
    menuOpen: function (val) {
      if (val) {
        if (this.index === 1 || this.index === 14) {
          this.$anime({
            targets: document.querySelector('.c-snow-wrapper'),
            opacity: [0, 1],
            delay: 200,
            duration: this.options.fadeOutTime,
            easing: this.options.easing
          })
        }
      } else {
        if (this.index === 1 || this.index === 14) {
          this.$anime({
            targets: document.querySelector('.c-snow-wrapper'),
            opacity: [1, 0],
            delay: 0,
            duration: this.options.fadeOutTime,
            easing: this.options.easing
          })
        }
      }
    }
  },

  mounted () {
    this.href = window.location.href
  },

  methods: {
    scrollToHome () {
      this.$root.$emit('scrollToHome')
      this.closeMenu()
    },

    closeMenu () {
      setTimeout(() => {
        this.menuOpen = false
      }, 500)
    },

    windowPopup (url, width, height) {
      const left = (screen.width / 2) - (width / 2)
      const top = (screen.height / 2) - (height / 2)

      window.open(
        url,
        '',
        'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left
      )
    }
  },

  computed: mapState({
    webP: state => state.webp,
    lang: state => state.language,
    globals (state) {
      const lang = this.lang
      return state.translations.general[lang]
    },
    extension () {
      return this.webP ? 'webp' : 'png'
    }
  }),

  components: {
    SocialShare,
    Img,
    Leafs
  }
}
</script>
